import { AttributeFieldProps } from "./RenderAttributeInput";
import {  OpenBlogSettingsFromEditor  } from "../Menus/BlogSettingsPopup";

export default function ManageBlogSettingsField({definition,layoutObject,updateFunc,saveFunc,screenSize,siteData,label}:AttributeFieldProps){

        //const val = GetComponentOrStyleValueFromDefinition(definition,siteData.siteStyling.misc,screenSize);

    
        return( 
     <div className="w-full center-all wb-input-group">
       
        <button className="w-button w-button-primary w-full" style={{margin:"16px 0px"}} onClick={()=>{
            let des = siteData.designer;
            if(!des)
                return
            let designer = siteData.designer;
            if(designer){
                OpenBlogSettingsFromEditor(designer);
                // designer.toggleLoading(true);
                // OpenBlogSettingsPopupAndCallAPI(siteData.userContext,des.state.postInfo,()=>designer!.toggleLoading(false));
            }   
         }}>Manage Post Settings</button>
         <br/>
     </div>
    );
}



